import {
  CarrierVisitCraneDto,
  CarrierVisitWithWorkQueueDto,
  CarrierVisitWorkQueueDto,
  OperationType,
  VesselArea,
  WorkInstructionControlRoomDto,
  WorkQueueStatus,
} from '@operations/app/api'

export type ControlRoomWorkTabType = 'vessel' | 'truck' | 'train' | 'internal'

// Sentinel id for the "Others" bucket — internal WIs with housekeepingPlanId === null.
// Kept on the UI side only; the backend never emits this value.
export const OTHERS_GROUP_ID = '__others__' as const

export interface HousekeepingGroupViewModel {
  id: string
  name: string
  progressLabel: string
  completedMovesCount: number
  totalMovesCount: number
  isOthers: boolean
}

export interface CarrierVisitViewModel extends CarrierVisitWithWorkQueueDto {
  cranes: CarrierVisitCraneViewModel[]
}

export interface CarrierVisitCraneViewModel extends CarrierVisitCraneDto {
  status?: WorkQueueStatus
  workQueues: CarrierVisitWorkQueueViewModel[]
}

export interface CarrierVisitWorkQueueViewModel extends CarrierVisitWorkQueueDto {
  status?: WorkQueueStatus
  workInstructionsAmount: number
  endTime?: Date
}

export interface WorkQueueRenameModel {
  id: number | string
  name?: string | null
  bay: number
  vesselArea: VesselArea
  operationType: OperationType
  startTime: string | Date
  endTime?: Date
}

export interface WorkInstructionViewModel extends WorkInstructionControlRoomDto {
  workQueueFromTime?: Date
  workQueueToTime?: Date
  workQueueName?: string | null
  craneName?: string
  lastEquipment?: string | null
  plannedTime?: Date
}
